import { render, staticRenderFns } from "./googleLogin.vue?vue&type=template&id=23424732&scoped=true&"
import script from "./googleLogin.vue?vue&type=script&lang=js&"
export * from "./googleLogin.vue?vue&type=script&lang=js&"
import style0 from "./googleLogin.vue?vue&type=style&index=0&id=23424732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23424732",
  null
  
)

export default component.exports